var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotificationInPage',{class:_vm.$style.notificationContainer,attrs:{"data-test-id":_vm.$testId('existingActivationInfoBanner'),"notification":_vm.notification,"showNotification":_vm.showNotification}})
}
var staticRenderFns = []

export { render, staticRenderFns }